export default "__VITE_ASSET__2f125647__"